import { useState } from "react";
import { useLocation } from "react-router-dom";

interface NavItemProps {
  label: string;
  to: string;
  /** Additional paths that should mark this item as active */
  activePaths?: string[];
}

const NavItem = ({ label, to, activePaths = [] }: NavItemProps) => {
  const { pathname } = useLocation();
  const [hovered, setHovered] = useState(false);

  const isActive =
    pathname.startsWith(to) ||
    activePaths.some((p) => pathname.startsWith(p));

  return (
    <a
      href={to}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="topbar-nav-item"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        padding: "0 4px",
        fontFamily: "Roboto, sans-serif",
        fontSize: "15px",
        fontWeight: isActive ? 600 : 400,
        color: isActive || hovered ? "#005bc7" : "#333333",
        textDecoration: "none",
        borderBottom: isActive ? "2px solid #005bc7" : "2px solid transparent",
        transition: "color 0.15s, border-color 0.15s",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </a>
  );
};

export default NavItem;
